module.exports = __webpack_public_path__ + "img/booking_action_black_icon.828f1fc7.svg";